<template>
    <div>
        <div>
            <h3>Fechamento horas funcionário</h3>
        </div>
        <span class="span-month">Mês de referência:</span>
        <date-picker
            v-model ="month"
            format="MMMM/YYYY"
            type="month"
            v-on:change="loadMonth"
        >
        </date-picker>
        <button v-if="!processed" class="btn btn-primary btns" @click="process" :disabled="loading">Processar</button>
        <button v-if="processed" class="btn btn-danger btns" @click="deleteProcess" :disabled="loading">Excluir</button>
        <button class="btn btn-primary btns" v-on:click="csv">Baixar CSV</button>

        <div v-if="loading" >
            <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
        </div>
        <div v-else>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th>Funcionário</th>
                    <th>Remuneração</th>
                    <th>FGTS</th>
                    <th>INSS</th>
                    <th>13° sal.</th>
                    <th>FGTS s/ 13° e férias </th>
                    <th>Férias</th>
                    <th>Adicionais</th>
                    <th>Descontos</th>
                    <th>Total Remuneração</th>
                    <th>Hora Trabalhadas</th>
                    <th>Horas potenciais</th>
                    <th>Aprov. Horas</th>
                    <th>Custo H. Trabalhada</th>
                    <th>Custo H. Total</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="employee in closure" :key="employee.user_id">
                    <td>{{ employee.name }}</td>
                    <td>{{ numberFormat(employee.salary) }}</td>
                    <td>{{ numberFormat(employee.fgts) }}</td>
                    <td>{{ numberFormat(employee.inss) }}</td>
                    <td>{{ numberFormat(employee.thirteenth_salary) }}</td>
                    <td>{{ numberFormat(employee.fgts_without_thirteenth_salary) }}</td>
                    <td>{{ numberFormat(employee.vacation) }}</td>
                    <td>{{ numberFormat(employee.additions) }}</td>
                    <td>{{ numberFormat(employee.discounts) }}</td>
                    <td>{{ numberFormat(employee.total) }}</td>
                    <td>{{ secondsToDate(employee.worked_total) }}</td>
                    <td>{{ secondsToDate(employee.workload_total) }}</td>
                    <td>{{ parseFloat(employee.percentage_worked).toFixed(2) }}%</td>
                    <td>{{ numberFormat(employee.cost_hours_worked) }}</td>
                    <td>{{ numberFormat(employee.cost_hours_workload) }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: 'EmployeeResume',
    components: {
        DatePicker
    },
    mounted () {
        this.loadMonth()
        this.init()
    },
    data () {
        return {
            month: new Date (),
            processed: false,
            closure: '',
            loading: true,
            users: '',
            loadingUser: false,
            loadingClosure: false
        }
    },
    computed: {
        ...mapGetters({
            token: 'auth/token',
        }),
    },    
    methods: {
        init () {
            this.processed = false
            this.loading = true
        },

        numberFormat (number) {
          return new Intl.NumberFormat('pt-BR',{style: 'currency', currency: 'BRL'}).format(number)
        },

        secondsToDate (seconds) {
            if (isNaN(seconds)) {
                return '00:00:00'
            }
            let hours = Math.floor(seconds / 3600)
            seconds %= 3600
            let minutes = Math.floor(seconds / 60)
            seconds = seconds % 60

            return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
        },

        loadMonth () {
            this.init()

            axios.get('/api/employee_cost_closure?year='
                + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                .then((response) => {
                    this.closure = response.data.data
                    this.loading = false
                    if (this.closure.length) {
                        this.processed = true
                    }
                })
        },

        process () {
            this.loading = true
            axios.post('/api/employee_cost_closure', {
                year: this.month.getFullYear(),
                month: this.month.getMonth() + 1
            })
                .then(() => {
                    this.loadMonth()
                }).catch(() => {
                this.$swal({
                    title: 'Ops...',
                    text: 'Não foi possível realizar o processamento!',
                    icon: 'error'
                })
            })
        },

        csv () {
            const year = this.month.getFullYear()
            const month = this.month.getMonth() + 1
            window.open(process.env.VUE_APP_URL + '/api/employee_cost_closure/csv?year='+year+'&month='+month+'&api_token='+ this.token)
        },

        deleteProcess () {
            this.$swal({
                title: 'Atenção',
                text: 'Realmente deseja excluir o processamento',
                icon: 'warning',
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete('/api/employee_cost_closure?year='
                        + this.month.getFullYear() + '&month=' + (this.month.getMonth() + 1))
                        .then(() => {
                            this.loadMonth()
                        })
                }
            })
        }
    }
}
</script>

<style lang="sass">
    .btns
        margin-left: 20px
</style>
